(function () {
  'use strict';

  var KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/S4cYEr/klaviyo.js?company_id=S4cYEr';
  var isLoaded = false;

  window.klaviyo = window.klaviyo || [];

  if (window.__klaviyoCustomerEmail) {
    window.klaviyo.push(['identify', { '$email': window.__klaviyoCustomerEmail }]);
  }

  function loadKlaviyo() {
    if (isLoaded) return;
    isLoaded = true;

    var script = document.createElement('script');
    script.src = KLAVIYO_SRC;
    script.async = true;
    script.setAttribute('data-klaviyo-onsite', 'true');
    document.head.appendChild(script);
  }

  function loadOnInteraction() {
    loadKlaviyo();
  }

  ['click', 'scroll', 'touchstart', 'keydown'].forEach(function (eventName) {
    document.addEventListener(eventName, loadOnInteraction, { once: true, passive: true });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadKlaviyo, { timeout: 5000 });
  } else {
    setTimeout(loadKlaviyo, 5000);
  }
})();
